<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<ng-container *ngIf="viewModules$ | async as vm">
<div *ngIf="!loading" class="flex flex-col h-full">

    <!-- FILTROS -->
    <div class="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-6">
        <!-- Filtros de data -->
        <div class="w-full lg:w-auto">
            <!-- Datas + Filtrar/Limpar: em mobile empilhado, lg na mesma linha -->
            <div class="flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-4">
                <!-- Datas: em mobile 1 col, sm+ 2 cols -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div class="flex items-center gap-2">
                        <label for="initialDate" class="text-sm font-medium text-westetics-neutral-700 whitespace-nowrap">De:</label>
                        <input 
                            type="date" 
                            id="initialDate" 
                            [(ngModel)]="initialDate" 
                            class="bg-white border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-westetics-purple-500 focus:border-transparent w-full"
                        />
                    </div>
                    <div class="flex items-center gap-2">
                        <label for="finalDate" class="text-sm font-medium text-westetics-neutral-700 whitespace-nowrap">Até:</label>
                        <input 
                            type="date" 
                            id="finalDate" 
                            [(ngModel)]="finalDate" 
                            class="bg-white border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-westetics-purple-500 focus:border-transparent w-full"
                        />
                    </div>
                </div>
                <!-- Botões Filtrar/Limpar -->
                <div class="flex flex-col sm:flex-row gap-2 sm:justify-center sm:items-center lg:justify-start">
                    <button 
                        (click)="onDateChange()"
                        class="py-2 px-4 rounded-lg font-medium text-sm bg-westetics-purple-800 text-white hover:bg-westetics-purple-700 transition-colors w-full sm:w-48 lg:w-auto"
                    >
                        Filtrar
                    </button>
                    <button 
                        *ngIf="initialDate || finalDate" 
                        (click)="clearDateFilters()"
                        class="py-2 px-4 rounded-lg font-medium text-sm border border-westetics-purple-800 text-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white transition-colors w-full sm:w-32 lg:w-auto"
                    >
                        Limpar
                    </button>
                </div>
            </div>
        </div>

        <!-- Botões de filtro por status -->
        <div class="flex flex-wrap gap-2 justify-center sm:justify-start">
            <button 
                (click)="changeFilter('NOT_COMPLETED')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'NOT_COMPLETED',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'NOT_COMPLETED'
                }"
            >
                Pendentes
            </button>
            <button 
                (click)="changeFilter('COMPLETED')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'COMPLETED',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'COMPLETED'
                }"
            >
                Respondidas
            </button>
            <button 
                (click)="changeFilter('ALL')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'ALL',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'ALL'
                }"
            >
                Todas
            </button>
        </div>
    </div>

    <!-- TABELA DESKTOP -->
    <div class="hidden md:block relative overflow-x-auto rounded-lg flex-1">
        <table class="w-full text-sm text-left text-gray-500 mb-8">
            <thead class="px-2 text-xs text-white bg-westetics-purple-300 mb-2">
                <tr class="text-left">
                    <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('createdAt')">
                        Data de Envio
                        <fa-icon [icon]="orderBy === 'createdAt' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                            [ngClass]="{'text-westetics-purple-800': orderBy === 'createdAt'}"></fa-icon>
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('patientName')">
                        {{vm.moduleNameInSingular}}
                        <fa-icon [icon]="orderBy === 'patientName' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                            [ngClass]="{'text-westetics-purple-800': orderBy === 'patientName'}"></fa-icon>
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('patientEmail')">
                        Email
                        <fa-icon [icon]="orderBy === 'patientEmail' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                            [ngClass]="{'text-westetics-purple-800': orderBy === 'patientEmail'}"></fa-icon>
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Telefone
                    </th>

                    <th *ngIf="filterType === 'ALL'" scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Status
                    </th>

                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Ações
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr 
                    *ngFor="let anamnese of anamneses" 
                    class="border-b hover:bg-gray-50 cursor-pointer" 
                    (click)="viewAnamnese(anamnese)"
                >
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ formatDate(anamnese.created_at) }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ anamnese.patient.full_name || '-' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ anamnese.patient.email || '-' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ anamnese.patient.phone || '-' }}
                    </td>
                    <td *ngIf="filterType === 'ALL'" class="p-4 text-sm">
                        <span class="flex items-center gap-2" [ngClass]="getStatusClass(anamnese.is_answered)">
                            <fa-icon [icon]="faCircle" class="text-[8px]"></fa-icon>
                            {{ getStatusText(anamnese.is_answered) }}
                        </span>
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        <div class="flex gap-3">
                            <button
                                (click)="viewAnamnese(anamnese); $event.stopPropagation()"
                                class="cursor-pointer text-westetics-purple-800 hover:text-westetics-purple-600"
                                title="Visualizar"
                            >
                                <fa-icon [icon]="faEye"></fa-icon>
                            </button>
                            <button *ngIf="!anamnese.is_answered"
                                (click)="deleteAnamnese(anamnese.id || ''); $event.stopPropagation()"
                                class="cursor-pointer text-westetics-purple-800 hover:text-red-600 transition-colors"
                                title="Excluir"
                            >
                                <fa-icon [icon]="faTrash"></fa-icon>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Mensagem quando não há anamneses -->
        <div *ngIf="anamneses.length === 0 && !loading" class="text-center py-8 text-westetics-neutral-600">
            {{vm.moduleName === 'PACIENTES' ? 'Nenhum anamnese encontrada.' : 'Nenhum formulário encontrado.'}}
        </div>
    </div>

    <!-- CARDS MOBILE -->
    <div class="md:hidden space-y-3 mb-6 flex-1">
        <div *ngFor="let anamnese of anamneses" 
             class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow cursor-pointer"
             (click)="viewAnamnese(anamnese)">
            <div class="flex justify-between items-start mb-3">
                <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-westetics-neutral-950 truncate">{{ anamnese.patient.full_name || '-' }}</h3>
                    <p class="text-xs text-westetics-neutral-600 truncate">{{ anamnese.patient.email || '-' }}</p>
                </div>
                <div class="flex items-center gap-2">
                    <span *ngIf="filterType === 'ALL'" class="flex items-center gap-1 text-xs px-2 py-0.5 rounded-full" [ngClass]="getStatusClass(anamnese.is_answered)">
                        <fa-icon [icon]="faCircle" class="text-[6px]"></fa-icon>
                        {{ getStatusText(anamnese.is_answered) }}
                    </span>
                    <button *ngIf="!anamnese.is_answered"
                        (click)="deleteAnamnese(anamnese.id || ''); $event.stopPropagation()"
                        class="p-2 rounded-lg hover:bg-gray-100 text-westetics-purple-800 hover:text-red-600 transition-colors"
                        title="Excluir"
                    >
                        <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                </div>
            </div>
            <div class="grid grid-cols-2 gap-2 text-xs">
                <div>
                    <span class="text-westetics-neutral-500">Data:</span>
                    <span class="ml-1 text-westetics-neutral-900">{{ formatDate(anamnese.created_at) }}</span>
                </div>
                <div>
                    <span class="text-westetics-neutral-500">Telefone:</span>
                    <span class="ml-1 text-westetics-neutral-900">{{ anamnese.patient.phone || '-' }}</span>
                </div>
            </div>
        </div>

        <!-- Mensagem quando não há anamneses -->
        <div *ngIf="anamneses.length === 0 && !loading" class="text-center py-8 text-westetics-neutral-600">
            {{vm.moduleName === 'PACIENTES' ? 'Nenhum anamnese encontrada.' : 'Nenhum formulário encontrado.'}}
        </div>
    </div>

    <!-- PAGINADOR -->
    <div *ngIf="anamneses.length > 0 && totalPages > 1" class="flex flex-col lg:flex-row items-center justify-between gap-3 py-4 px-3 lg:px-5">
      <!-- Info de resultados -->
      <div class="text-xs lg:text-sm text-gray-600 order-3 lg:order-1">
        Mostrando {{ (currentPage * pageSize) + 1 }} - {{ Math.min((currentPage + 1) * pageSize, totalElements) }} de {{ totalElements }} {{vm.moduleName === 'PACIENTES' ? 'anamneses' : 'formulários'}}
      </div>
      
      <!-- Controles de paginação -->
      <div class="flex items-center gap-1 lg:gap-2 order-1 lg:order-2">
        <!-- Botão Anterior -->
        <button (click)="goToPreviousPage()" 
                [disabled]="currentPage === 0"
                [ngClass]="{'opacity-50 cursor-not-allowed': currentPage === 0}"
                class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        
        <!-- Números das páginas -->
        <div class="flex items-center gap-1">
          <button *ngFor="let page of generatePagination(currentPage + 1, totalPages)"
                  (click)="navigateTo(page)"
                  [disabled]="page === '...'"
                  [ngClass]="{
                    'bg-westetics-purple-600 text-white': page === currentPage + 1,
                    'hover:bg-gray-50': page !== currentPage + 1 && page !== '...',
                    'cursor-default': page === '...'
                  }"
                  class="min-w-[32px] lg:min-w-[36px] px-2 lg:px-3 py-1.5 lg:py-2 border border-gray-300 rounded-md transition-colors text-xs lg:text-sm">
            {{ page }}
          </button>
        </div>
        
        <!-- Botão Próximo -->
        <button (click)="goToNextPage()" 
                [disabled]="currentPage + 1 >= totalPages"
                [ngClass]="{'opacity-50 cursor-not-allowed': currentPage + 1 >= totalPages}"
                class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>

      <!-- Seletor de itens por página -->
      <div class="flex items-center gap-2 text-xs lg:text-sm order-2 lg:order-3">
        <span class="text-gray-600">Por página:</span>
        <select [value]="pageSize" (change)="changePageSize($event)"
                class="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-500">
          <option *ngFor="let opt of pageSizeOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </div>
    </div>
</div>

<!-- MODAL DE CONFIRMAÇÃO DE EXCLUSÃO DE ANAMNESE -->
<div *ngIf="showConfirmDeletePopup" 
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    (click)="!confirmDeleteLoading && closeDeleteModal()">
    <div class="bg-white rounded-lg p-6 w-[480px] max-w-[95vw] shadow-lg mx-4" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center mb-4">
            <h2 class="font-bold text-lg text-westetics-neutral-950">Confirmar exclusão</h2>
            <button (click)="closeDeleteModal()" 
                [disabled]="confirmDeleteLoading"
                class="text-westetics-neutral-600 hover:text-westetics-neutral-900 disabled:opacity-50 disabled:cursor-not-allowed">
                <fa-icon [icon]="faTimes"></fa-icon>
            </button>
        </div>
        <p class="text-sm text-westetics-neutral-800 mb-6">
            Tem certeza que deseja excluir esta anamnese? Esta ação não pode ser desfeita.
        </p>
        <div class="flex justify-end gap-3">
            <button (click)="closeDeleteModal()"
                [disabled]="confirmDeleteLoading"
                class="px-4 py-2 text-sm font-medium rounded-lg text-westetics-purple-800 hover:bg-westetics-purple-800 border-westetics-purple-800 border hover:text-white disabled:opacity-50 disabled:cursor-not-allowed">
                Cancelar
            </button>
            <button (click)="confirmDelete()"
                [disabled]="confirmDeleteLoading"
                class="px-4 py-2 text-sm font-medium text-white bg-westetics-purple-800 rounded-lg hover:bg-westetics-purple-300 disabled:opacity-50 disabled:cursor-not-allowed">
                <ng-container *ngIf="!confirmDeleteLoading">Excluir</ng-container>
                <div *ngIf="confirmDeleteLoading" class="flex items-center gap-2">
                    <app-loading-spinner size="xs"></app-loading-spinner>
                    <span>Excluindo...</span>
                </div>
            </button>
        </div>
    </div>
</div>
</ng-container>
